// prop types
import PropTypes from "prop-types";

import checkAjaxValue from "./ajax-value";
import datePickerTypeCheck from "./date-picker";
import momentCheck from "./moment";
import styleObjectPropType from "./style-object";

export default {
	...PropTypes,
	moment: momentCheck,
	ajaxValue: checkAjaxValue,
	datePicker: datePickerTypeCheck,
	styleObject: styleObjectPropType,
};
